import { render, staticRenderFns } from "./TextGroup.vue?vue&type=template&id=1e87fdc8&"
import script from "./TextGroup.vue?vue&type=script&lang=js&"
export * from "./TextGroup.vue?vue&type=script&lang=js&"
import style0 from "./TextGroup.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports